module.exports = __webpack_public_path__ + "img/bg_gongcan.f8507948.png";